import { create } from "zustand";

interface TripsState {
  temporaryWaypointOrder: Record<string, number> | undefined;
  setTemporaryWaypointOrder: (
    order: Record<string, number> | undefined
  ) => void;
}

export const useTripsStore = create<TripsState>((set) => ({
  temporaryWaypointOrder: undefined,
  setTemporaryWaypointOrder: (order) => set({ temporaryWaypointOrder: order }),
}));
